define.alias("shared/components/shared/video-player", "preview-grid/components/shared/video-player");